// ============================================================================
// IMAGENS DO SITE — Dra. Sâmia Albuquerque
// ============================================================================
// Troque os links abaixo pelas suas imagens reais.
// Você pode usar o "Go to Code" no editor visual, ou abrir este arquivo direto.
//
// FORMATO: cole o URL da imagem entre as aspas.
// Exemplo: export const aboutImage = "https://seudominio.com/foto.jpg";
// ============================================================================

// Hero — imagem de fundo da tela inicial
export const heroImage =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/bbdee830-d045-4339-80e2-7a3a366da7e2_compressed_Imagem-do-Codex-30-de-ago.-de-2026-09_39_15.webp";

// Sobre — retrato profissional da Dra. Sâmia (lado esquerdo da seção "Sobre")
export const aboutImage =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/041540e6-5df9-4c3f-a8b6-570d4c9bd9c2_compressed_Captura-de-tela-2026-08-30-101622.webp";

// Experiência — galeria de 4 imagens (seção "Experiência e ambiente")
export const expImage1 =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/a81c4ff4-98e1-4f8e-a13e-714fdd40a9ec_compressed_Captura-de-tela-2026-08-30-101638.webp";

export const expImage2 =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/cb0c0774-1faf-4340-aafb-78acbe43a71c_compressed_Captura-de-tela-2026-08-30-102059.webp";

export const expImage3 =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/b3dfba2c-54b0-49d3-af53-d19e059ef743_compressed_Captura-de-tela-2026-08-30-102009.webp";

export const expImage4 =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/78e4abac-5521-4024-b028-8a867bc161a5_compressed_Captura-de-tela-2026-08-30-102843.webp";

// PISOM — imagem do equipamento laser (seção "Tecnologia PISOM")
export const pisomImage =
  "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/7452ba24-58c5-46f4-b1cf-e8d2fd0385ce_compressed_Captura-de-tela-2026-08-30-101935.webp";

// Instagram feed — substitua pelas imagens reais dos posts
export const instaImage1 =
  "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/2c8a45e6cdf0c33b9ba4852bb40ab397.png";

export const instaImage2 =
  "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/a2301386e290cd8f496ba2a64dee5764.png";

export const instaImage3 =
  "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/7cad11178457966e02d0aca4751ccf48.png";

export const instaImage4 =
  "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/02e0500b268108ef3831e8e133da2489.png";

export const instaImage5 =
  "https://readdy.ai/api/search-image?query=Serene%20spa-like%20treatment%20room%20with%20soft%20ambient%20lighting%2C%20dark%20sophisticated%20walls%2C%20fresh%20white%20towels%20and%20orchids%2C%20luxury%20wellness%20aesthetic%2C%20champagne%20and%20black%20color%20palette%2C%20editorial%20photography&width=600&height=600&seq=insta-5&orientation=squarish";

export const instaImage6 =
  "https://readdy.ai/api/search-image?query=Before%20and%20after%20skincare%20concept%20with%20side%20lighting%2C%20dark%20moody%20background%2C%20elegant%20hands%20touching%20face%2C%20warm%20golden%20tones%2C%20luxury%20beauty%20editorial%2C%20minimalist%20aesthetic%20medicine%20visual&width=600&height=600&seq=insta-6&orientation=squarish";